import * as Long from 'long';

function chunkArray(arr, size) {
    return arr.length > size
        ? [arr.slice(0, size), ...chunkArray(arr.slice(size), size)]
        : [arr];
}
function groupBy(arr, func) {
    const result = {};
    for (const value of arr) {
        const key = func(value);
        if (result[key] === undefined) {
            result[key] = [];
        }
        result[key].push(value);
    }
    return result;
}
function combineToArray(value, defaultValue) {
    if (Array.isArray(value)) {
        return value;
    }
    else if (value !== undefined) {
        return [value];
    }
    else if (defaultValue !== undefined) {
        return [defaultValue];
    }
    return [];
}
function string2LongAsBit(str) {
    return Long.fromNumber(str.charCodeAt(0)).
        add(Long.fromNumber(str.charCodeAt(1)).shiftLeft(8)).
        add(Long.fromNumber(str.charCodeAt(2)).shiftLeft(16)).
        add(Long.fromNumber(str.charCodeAt(3)).shiftLeft(24)).
        add(Long.fromNumber(str.charCodeAt(4)).shiftLeft(32)).
        add(Long.fromNumber(str.charCodeAt(5)).shiftLeft(40)).
        add(Long.fromNumber(str.charCodeAt(6)).shiftLeft(48)).
        add(Long.fromNumber(str.charCodeAt(7)).shiftLeft(56));
}
function diffArray(currentArray, newArray) {
    const removed = currentArray.filter(x => !newArray.includes(x));
    const added = newArray.filter(x => !currentArray.includes(x));
    return {
        added,
        removed
    };
}
function isTrueValue(ext, key) {
    if (ext === undefined || key === undefined) {
        return false;
    }
    return ext[key] === 'true' || ext[key] === '1';
}

export { chunkArray, combineToArray, diffArray, groupBy, isTrueValue, string2LongAsBit };
//# sourceMappingURL=tools.js.map
